export default __webpack_public_path__ + "static/media/visa.da14373f.svg";